const React = require("react")
const Layout = require("./src/components/Layout/Layout").default;

// eslint-disable-next-line
exports.wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>
};

// DIV-6027: Fix Alabama default state in Snipcart checkout
exports.onClientEntry = () => {
  // Poll for Snipcart availability
  const snipcartPollInterval = setInterval(() => {
    if (window.Snipcart && window.Snipcart.events) {
      clearInterval(snipcartPollInterval);
      initSnipcartStateFix();
    }
  }, 100);
  
  // Safety timeout to stop polling after 30 seconds
  setTimeout(() => {
    clearInterval(snipcartPollInterval);
  }, 30000);
};

function initSnipcartStateFix() {
  console.log('[Snipcart Fix] Initializing state dropdown fix...');
  
  // Listen for when Snipcart is ready
  document.addEventListener('snipcart.ready', () => {
    console.log('[Snipcart Fix] Snipcart ready event fired');
    
    // Fix on cart opened
    window.Snipcart.events.on('cart.opened', () => {
      console.log('[Snipcart Fix] Cart opened, scheduling fix...');
      setTimeout(() => fixStateDropdown(), 100);
    });
    
    // Fix when navigating to address step
    window.Snipcart.events.on('checkout.step.navigated', (step) => {
      console.log('[Snipcart Fix] Step navigated to:', step.to);
      if (step.to === 'address') {
        setTimeout(() => fixStateDropdown(), 100);
      }
    });

    // Also set up mutation observer for dynamic changes
    setupMutationObserver();
  });
}

function setupMutationObserver() {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      // Check if province-target select was added
      if (mutation.addedNodes.length > 0) {
        const provinceSelect = document.querySelector('select[name="province-target"]');
        if (provinceSelect && provinceSelect.value === 'Alabama') {
          console.log('[Snipcart Fix] MutationObserver detected Alabama, fixing...');
          fixStateDropdown();
        }
      }
    }
  });

  // Observe the entire document for added nodes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function fixStateDropdown() {
  console.log('[Snipcart Fix] Running fixStateDropdown...');
  
  // Find the hidden select that actually submits the value
  const hiddenSelect = document.querySelector('select[name="province-target"]');
  
  if (!hiddenSelect) {
    console.log('[Snipcart Fix] Hidden select not found, retrying...');
    // Retry after a short delay if not found
    setTimeout(() => fixStateDropdown(), 200);
    return;
  }

  console.log('[Snipcart Fix] Found hidden select, current value:', hiddenSelect.value);

  // Only proceed if it's currently set to Alabama (the default)
  if (hiddenSelect.value !== 'Alabama') {
    console.log('[Snipcart Fix] Value is not Alabama, skipping fix');
    return;
  }

  // Clear the hidden select
  hiddenSelect.value = '';
  
  // Trigger change event to update Snipcart's internal state
  const changeEvent = new Event('change', { bubbles: true });
  hiddenSelect.dispatchEvent(changeEvent);

  // Also clear the visual dropdown component
  const visualDropdown = document.querySelector('.Dropdown-placeholder');
  if (visualDropdown) {
    visualDropdown.textContent = 'Select State/Province';
    visualDropdown.classList.remove('is-selected');
  }

  console.log('[Snipcart Fix] State cleared, value now:', hiddenSelect.value);

  // Add validation listener to the form
  setupValidation(hiddenSelect);
}

function setupValidation(hiddenSelect) {
  // Mark as required
  hiddenSelect.setAttribute('required', 'required');

  // Find the next/continue button
  const observer = new MutationObserver(() => {
    const nextButton = document.querySelector('button[type="submit"]');
    if (nextButton && !nextButton.dataset.stateValidationAdded) {
      nextButton.dataset.stateValidationAdded = 'true';
      
      nextButton.addEventListener('click', function(event) {
        const currentValue = hiddenSelect.value;
        
        if (!currentValue || currentValue === '') {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          
          // Highlight the dropdown
          const visualDropdown = document.querySelector('.Dropdown-root');
          if (visualDropdown) {
            visualDropdown.style.border = '2px solid #d32f2f';
            visualDropdown.style.backgroundColor = '#ffebee';
          }
          
          // Show error message
          alert('Please select your State/Province before continuing.');
          
          console.log('[Snipcart Fix] Blocked submission - no state selected');
          return false;
        }
      }, true); // Use capture phase to intercept before Snipcart
      
      console.log('[Snipcart Fix] Validation listener added to submit button');
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}
